import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const SUPABASE_STORAGE_URL = "https://wxniywyujrxlwraocszi.supabase.co/storage/v1/object/public/product-images";

export function normalizeImageUrl(url: string | undefined): string {
  if (!url) return '/placeholder.svg';
  
  let normalizedUrl = url;
  
  // Transform localhost Medusa URLs to Supabase storage URLs
  if (url.includes('localhost:9000') || url.includes('localhost:7001')) {
    // Extract filename from the URL (last part after the last slash)
    const filename = url.split('/').pop();
    if (filename) {
      return `${SUPABASE_STORAGE_URL}/${filename}`;
    }
    return '/placeholder.svg';
  }
  
  // Upgrade HTTP to HTTPS for non-localhost URLs
  if (normalizedUrl.startsWith('http://') && !normalizedUrl.includes('localhost')) {
    normalizedUrl = normalizedUrl.replace('http://', 'https://');
  }
  
  return normalizedUrl;
}
